var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindowGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.333H2A.667.667 0 001.333 2v12a.666.666 0 00.667.667h12a.666.666 0 00.667-.667V2A.666.666 0 0014 1.333zm-8.667 12H2.667V2.667h2.666zm8 0H6.667V8.667h6.666zm0-6H6.667V2.667h6.666z",
    fill: "#815500"
  })));
}
export default SvgWindowGrid;